module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"headerTooltip":"The chart presents an average price in stores displayed in the widget (default settings).To check the average price in other stores, use the filter selected stores."}}')
  delete Component.options._Ctor
}
